<template>
  <div class="subtitle">
    <div
      v-for="checkbox in checkboxes"
      :key="checkbox.id"
      class="subtitle-item"
    >
      <input
        type="checkbox"
        :name="checkbox.name"
        :checked="isSelected(checkbox.name)"
        @change="onChangeCheckbox(checkbox.name)"
      />
      <span :style="{ backgroundColor: checkbox.color }"></span>
      {{ checkbox.label }}
      <span v-b-tooltip.hover :title="checkbox.tooltip" class="icon-tooltip">
        <i class="icofont-info-circle"></i>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Subtitle',
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    reset: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      checkboxes: [
        {
          id: 1,
          name: 'baixo',
          color: '#2cb947',
          label: 'Baixo',
          tooltip: ' <5%',
        },
        {
          id: 2,
          name: 'moderado',
          color: '#bfc300',
          label: 'Moderado',
          tooltip: ' 5% a <10%',
        },
        {
          id: 3,
          name: 'alto',
          color: '#ec7f22',
          label: 'Alto',
          tooltip: ' 10% a <20%',
        },
        {
          id: 4,
          name: 'muitoAlto',
          color: '#bc0020',
          label: 'Muito alto',
          tooltip: ' 20% a <30%',
        },
        {
          id: 5,
          name: 'critico',
          color: '#4d0005',
          label: 'Crítico',
          tooltip: ' >=30%',
        },
      ],
      selectedCheckbox: null,
    }
  },
  watch: {
    reset(newValue) {
      if (newValue === null) {
        this.selectedCheckbox = null
        this.$emit('onChangeCheckbox', this.selectedCheckbox)
      }
    },
  },
  methods: {
    isSelected(checkboxName) {
      return this.selectedCheckbox === checkboxName
    },
    onChangeCheckbox(checkboxName) {
      if (this.selectedCheckbox === checkboxName) {
        this.selectedCheckbox = null
      } else {
        this.selectedCheckbox = checkboxName
      }
      this.$emit('onChangeCheckbox', this.selectedCheckbox)
    },
  },
}
</script>

<style></style>
